import {
  DragItem,
  DropItem,
} from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-drop.constants';
import { ComponentInteractiveResponseSequence } from '../../../component.constants';
import type { GetActivitiesSectionsQuery } from '../../../../lesson-builder.graphql.generated';
import { ACTIVITIES_ANSWER_MODE_FREE } from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<
  ComponentInteractiveResponseSequence,
  '__typename'
>;
export type EditProps = ViewProps;
export type SettingProps = EditProps;
export type InteractiveResponseProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesInteractiveResponseComponent' }
  >,
  'properties'
>;
export type InteractiveResponseItem = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesInteractiveResponseComponent' }
  >,
  'properties.interactiveResponse.items'
>;

export const DROP_ITEM_SIZE = 104;
export const MIN_LABEL_WIDTH = 104;
export const MAX_SEQUENCE_ITEMS = 12;

export const RESPONSE_FIXED = null; // null or 'fixed' for backwards compatibility
export const RESPONSE_FREE = ACTIVITIES_ANSWER_MODE_FREE;

export type InteractiveSequenceAttempt = (
  dropItems: DropItem[],
  dragItems: DragItem[]
) => void;
